import * as React from "react";
import DOMPurify from "dompurify";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

export interface YesNoCancelPopupProps {
  visible: boolean;
  title: string;
  message?: string;
  yesButtonText?: string;
  noButtonText?: string;
  cancelButtonText?: string;
  onYes: () => void;
  onNo: () => void;
  onCancel?: () => void;
}

export const YesNoCancelPopup = ({
  visible,
  title,
  message,
  yesButtonText = "Yes",
  noButtonText = "No",
  cancelButtonText = "Cancel",
  onYes,
  onNo,
  onCancel,
}: YesNoCancelPopupProps) => {
  return (
    <Dialog open={visible} onClose={onCancel}>
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      {message !== undefined && (
        <DialogContent>
          <DialogContentText id="alert-dialog-message" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(message) }} />
        </DialogContent>
      )}
      <DialogActions>
        {onCancel && (
          <Button onClick={onCancel} color="inherit">
            {cancelButtonText}
          </Button>
        )}
        <Button onClick={onNo} color="error">
          {noButtonText}
        </Button>
        <Button onClick={onYes} color="primary" variant="contained">
          {yesButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
